export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-palette-line',
      title: 'プロ品質のデザイン',
      description: 'AI搭載の制作ツールで美しいHPを短期間で制作'
    },
    {
      icon: 'ri-rocket-line',
      title: '最短1週間で公開',
      description: 'ヒアリングから公開までスピーディーに対応'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: '月額4,980円〜',
      description: '初期費用ゼロ。月々の負担を最小限に'
    },
    {
      icon: 'ri-code-box-line',
      title: '12ヶ月後にコード譲渡',
      description: '制作したHPのソースコードをお客様にお渡し'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 mb-4">
            サクッとHPとは？
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 border-2 border-slate-200 hover:border-cyan-600 transition-all duration-300 hover:shadow-xl"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyan-600 to-cyan-700 rounded-full mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-800 mb-4">
                {feature.title}
              </h3>
              <p className="text-slate-600 text-lg leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}